module.exports = __webpack_public_path__ + "img/qp_03.aa126acd.jpg";